import { render, staticRenderFns } from "./videoUpload.vue?vue&type=template&id=08059036&scoped=true&"
import script from "./videoUpload.vue?vue&type=script&lang=js&"
export * from "./videoUpload.vue?vue&type=script&lang=js&"
import style0 from "./videoUpload.vue?vue&type=style&index=0&id=08059036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08059036",
  null
  
)

export default component.exports